// Clearance includes the capsule's raised equatorial seam, at every rotation.
export const CHAMBER={centerY:2.43,outerRadius:1.025,innerRadius:.995,floor:1.79,ceiling:3.23,capsuleRadius:.235,capsuleEnvelope:.247};
export function capsuleLayout(){
  const positions=[{x:0,y:2.05,z:0}];
  for(const [y,r,offset] of [[2.05,.52,0],[2.48,.52,Math.PI/6],[2.91,.50,0]]){
    for(let i=0;i<6;i++){
      const angle=i*Math.PI/3+offset;
      positions.push({x:Math.cos(angle)*r,y,z:Math.sin(angle)*r});
    }
  }
  return positions;
}
export function capsuleDisplayPose(rest,time,churn){
  // Stir the packed bed together so its clearance survives the whole animation.
  const angle=Math.sin(time*9)*.12*churn,c=Math.cos(angle),s=Math.sin(angle);
  return {x:rest.x*c-rest.z*s,y:rest.y+Math.abs(Math.sin(time*11))*.045*churn,z:rest.x*s+rest.z*c};
}
